/**
 * Motsvarar de bredder som är definierade i bootstraps _variables.scss.
 */
const deviceTypes = [{
    width: 1800,
    size: "xl"
},{
    width: 1200,
    size: "lg"
}, {
    width: 992,
    size: "md"
}, {
    width: 600,
    size: "sm"
}, {
    size: "xs"
}];

const findDeviceType = w => {
    return deviceTypes.filter(dt => (dt.width || 0) <= w)[0].size;
};

export const SET_DEVICE_TYPE = "SET_DEVICE_TYPE";
export const SET_INNER_HEIGHT = "SET_INNER_HEIGHT";
export const SET_INNER_WIDTH = "SET_INNER_WIDTH";

/**
 * Returnerar action för enhetens skärmstorlekstyp enligt bootstraps indelning i xs, sm, etc.
 * 
 * @param {number} width
 * @returns {Object}
 */
export function setDeviceType(width) {
    return {
        type: SET_DEVICE_TYPE,
        deviceType: findDeviceType(width)
    };
}

/**
 * Sätter browserns inre höjd.
 * @param {number} innerHeight
 * @returns {Object}
 */
export function setInnerHeight(innerHeight){
    return {
        type: SET_INNER_HEIGHT,
        innerHeight
    };
}

/**
 * Sätter browserns inre bred.
 * @param {number} innerWidth
 * @returns {Object}
 */
export function setInnerWidth(innerWidth){
    return {
        type: SET_INNER_WIDTH,
        innerWidth
    };
}